// Каждая запись — сворачиваемая группа со стеком вызовов: раскрываешь и видишь,
// кто инициировал отправку/событие. Chrome с включёнными async stack traces
// показывает и цепочку через await. Внутри группы дублируем запись родным
// уровнем (warn/error) — сохраняются цвет и фильтрация по уровню в DevTools.
function emit(
    level: (...args: unknown[]) => void,
    prefix: string,
    args: unknown[]
): void {
    console.groupCollapsed(prefix, ...args);
    if (level !== console.info) {
        level(prefix, ...args);
    }
    console.trace();
    console.groupEnd();
}

export function useLog(scope: string) {
    const prefix = `[${scope}]`;

    return {
        info: (...args: unknown[]) => emit(console.info, prefix, args),
        warn: (...args: unknown[]) => emit(console.warn, prefix, args),
        error: (...args: unknown[]) => emit(console.error, prefix, args),
    };
}
